<template>
  <GestionVariables />
</template>
<script setup>
import GestionVariables from "@/views/admin/variables/components/GestionVariables.vue";
</script>
